import React, { useEffect, useState } from 'react';
import { api } from '../../services/api';
import BankAccountForm from './BankAccountForm';
import styles from './BankAccounts.module.css';

export default function BankAccountsPage({ user }) {
  const [accounts, setAccounts] = useState([]);
  const [editing, setEditing] = useState(null); // null=hidden, {}=new, {id,...}=edit
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const data = await api.getBankAccounts(user.credential);
      setAccounts(data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []); // eslint-disable-line

  const handleSave = async (form) => {
    if (editing?.id) {
      await api.updateBankAccount(user.credential, editing.id, form);
    } else {
      await api.createBankAccount(user.credential, form);
    }
    setEditing(null);
    load();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('למחוק חשבון בנק זה?')) return;
    await api.deleteBankAccount(user.credential, id);
    load();
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2>חשבונות בנק</h2>
        {!editing && (
          <button className={styles.addBtn} onClick={() => setEditing({})}>
            + הוסף חשבון
          </button>
        )}
      </div>

      {editing && (
        <BankAccountForm
          account={editing?.id ? editing : null}
          onSave={handleSave}
          onCancel={() => setEditing(null)}
        />
      )}

      {loading && <p className={styles.empty}>טוען...</p>}

      {!loading && accounts.length === 0 && !editing && (
        <p className={styles.empty}>אין חשבונות בנק. הוסף את הראשון.</p>
      )}

      {accounts.map((acc) => (
        <div key={acc.id} className={styles.card}>
          <div className={styles.cardInfo}>
            <h4>{acc.accountOwnerName}</h4>
            <p>{acc.bankName} ({acc.bankNumber}) | סניף {acc.branchNumber} | חשבון {acc.accountNumber}</p>
            <p className={styles.cardMeta}>
              {acc.requestCount > 0
                ? `${acc.requestCount} בקשות | אחרונה: ${new Date(acc.lastRequestDate).toLocaleDateString('he-IL')}`
                : 'ללא בקשות'}
            </p>
          </div>
          <div className={styles.cardActions}>
            <button className={styles.btnEdit} onClick={() => setEditing(acc)}>ערוך</button>
            <button className={styles.btnDanger} onClick={() => handleDelete(acc.id)}>מחק</button>
          </div>
        </div>
      ))}
    </div>
  );
}
